import { useState } from "react";
import { Panel, Label } from "@/components/SplitLayout";
import CopyButton from "@/components/CopyButton";
import { ArrowClockwise } from "@phosphor-icons/react";

const WORDS = "lorem ipsum dolor sit amet consectetur adipiscing elit sed do eiusmod tempor incididunt ut labore et dolore magna aliqua enim ad minim veniam quis nostrud exercitation ullamco laboris nisi aliquip ex ea commodo consequat duis aute irure in reprehenderit voluptate velit esse cillum fugiat nulla pariatur excepteur sint occaecat cupidatat non proident sunt culpa qui officia deserunt mollit anim id est laborum".split(" ");

const rand = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;
const cap = (w) => w.charAt(0).toUpperCase() + w.slice(1);

const makeSentence = () => {
  const len = rand(6, 14);
  const parts = Array.from({ length: len }, () => WORDS[rand(0, WORDS.length - 1)]);
  let s = parts.join(" ");
  if (rand(0, 2) === 0) {
    const i = rand(2, len - 2);
    parts[i] = parts[i] + ",";
    s = parts.join(" ");
  }
  return cap(s) + ".";
};

const makeParagraph = () => {
  const count = rand(4, 7);
  return Array.from({ length: count }, makeSentence).join(" ");
};

export default function LoremIpsum() {
  const [count, setCount] = useState(3);
  const [unit, setUnit] = useState("paragraphs");
  const [startLorem, setStartLorem] = useState(true);
  const [output, setOutput] = useState("");

  const generate = () => {
    let result = "";
    if (unit === "paragraphs") {
      const paras = Array.from({ length: count }, makeParagraph);
      if (startLorem) {
        paras[0] = "Lorem ipsum dolor sit amet, consectetur adipiscing elit. " + paras[0];
      }
      result = paras.join("\n\n");
    } else if (unit === "sentences") {
      result = Array.from({ length: count }, makeSentence).join(" ");
    } else {
      const w = Array.from({ length: count }, () => WORDS[rand(0, WORDS.length - 1)]);
      if (startLorem) w[0] = "lorem";
      result = cap(w.join(" ")) + ".";
    }
    setOutput(result);
  };

  return (
    <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
      <div className="space-y-6">
        <Panel title="Options">
          <div className="space-y-5">
            <div className="space-y-2">
              <Label>Amount</Label>
              <input
                data-testid="lorem-count"
                type="number"
                min={1}
                max={50}
                value={count}
                onChange={(e) => setCount(Math.min(50, Math.max(1, +e.target.value || 1)))}
                className="w-full border border-border bg-card px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-primary"
              />
            </div>
            <div className="space-y-2">
              <Label>Unit</Label>
              <div className="flex flex-wrap gap-2">
                {["paragraphs", "sentences", "words"].map((u) => (
                  <button
                    key={u}
                    data-testid={`lorem-unit-${u}`}
                    onClick={() => setUnit(u)}
                    className={`border px-4 py-2 text-xs font-bold uppercase tracking-[0.1em] transition-all duration-150 ${
                      unit === u
                        ? "border-primary bg-primary text-primary-foreground"
                        : "border-border bg-card hover:border-primary hover:text-primary"
                    }`}
                  >
                    {u}
                  </button>
                ))}
              </div>
            </div>
            <label className="flex items-center gap-3 text-sm">
              <input
                data-testid="lorem-start-toggle"
                type="checkbox"
                checked={startLorem}
                onChange={(e) => setStartLorem(e.target.checked)}
                className="h-4 w-4 accent-[hsl(var(--primary))]"
              />
              Start with “Lorem ipsum…”
            </label>
            <button
              data-testid="lorem-generate"
              onClick={generate}
              className="inline-flex w-full items-center justify-center gap-2 bg-primary px-5 py-3 text-xs font-bold uppercase tracking-[0.12em] text-primary-foreground transition-transform duration-150 hover:-translate-y-0.5 active:scale-[0.98]"
            >
              <ArrowClockwise size={16} weight="bold" /> Generate
            </button>
          </div>
        </Panel>
      </div>

      <div className="lg:sticky lg:top-24 lg:self-start">
        <Panel
          title="Generated text"
          testId="lorem-output"
          action={output ? <CopyButton text={output} /> : null}
        >
          <div className="min-h-[300px] whitespace-pre-wrap text-sm leading-relaxed text-muted-foreground">
            {output || "Click Generate to create placeholder text…"}
          </div>
        </Panel>
      </div>
    </div>
  );
}
